import React from 'react'
import { RegisterFilterScopes } from '../types'
import { RegisterItem } from '@core/entities/register/RegisterItem'
import { localizedStrings } from '@core/strings'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import { CreateEditRegisterItemModal } from '@modules/registers/modals/CreateEditRegisterItemModal'
import { PageUrls } from '@core/page-urls'
import { Button, DropdownButton } from '@common/material'
import ArrowDropDown from '@mui/icons-material/ArrowDropDown'
import { RegisterTemplate } from '@core/entities/register/RegisterTemplate'
import { Register } from '@core/entities/register/Register'
import { useModal } from '@common/GlobalModal'
import { useRouter } from 'next/router'
import { FactCheckOutlined } from '@mui/icons-material'
import { encodeReturnUrl } from 'webapp/utils'

type RegisterItemDetailsProps = {
  scope: RegisterFilterScopes
  register: Register
  registerItem: RegisterItem
  registerTemplate: RegisterTemplate
  registerViewId: number
}
export const RegisterItemDetailsActions: React.FC<RegisterItemDetailsProps> = ({
  scope,
  register,
  registerItem,
  registerTemplate,
  registerViewId,
}) => {
  const { showModal } = useModal()
  const router = useRouter()

  const options = []
  if (register?.canUpdateItems()) {
    options.push({
      title: localizedStrings.updateItem,
      icon: <EditOutlinedIcon />,
      onSelect: () =>
        showModal(
          <CreateEditRegisterItemModal
            scope={scope}
            registerTemplate={registerTemplate}
            register={register}
            registerItem={registerItem}
            registerViewId={registerViewId}
          />,
        ),
    })
  }

  if (register?.projectId) {
    options.push({
      title: localizedStrings.newChecklist,
      'data-test': 'new-checklist-from-register-item',
      icon: <FactCheckOutlined />,
      onSelect: () => {
        const returnUrl = encodeReturnUrl({
          pathname: router.pathname,
          query: router.query,
        })

        router.push({
          pathname: PageUrls.newChecklistProject({
            organisationId: scope.organisationId,
            projectId: register.projectId,
          }),
          query: {
            registerId: register.id,
            registerItemId: registerItem.id,
            projectId: register.projectId,
            returnUrl,
          },
        })
      },
    })
  }

  return (
    <DropdownButton
      label={localizedStrings.new}
      options={options}
      fullWidth
      renderButton={(onClick) => (
        <Button
          onClick={(e) => {
            onClick(e)
            e.stopPropagation()
          }}
          onBlur={(e) => {
            e.stopPropagation()
          }}
          variant='outlined'
          endIcon={<ArrowDropDown />}
          sx={{
            fontSize: 16,
            ml: 1,
          }}
        >
          {localizedStrings.actions}
        </Button>
      )}
    />
  )
}
